import { RAC_getWorkingPatch } from "./patches";
import { uggGetProfileIconImg } from "../static-url-helpers";

export function RAC_getProfileIconImg(versions) {
  return (id, { webp } = {}) => {
    const latestPatch = RAC_getWorkingPatch(versions)();
    return uggGetProfileIconImg(latestPatch, id, { webp });
  };
}
